interface Props {
  label?: string;
  placeholder: string;
  id?: string;
  rows: number;
  dataField: string;
  formData: any;
  setStateMethod: any;
  value?: any;
  customColClassForLabel?: any;
  customColClassForValue?: any;
  disabled?: boolean;
}

export const TextArea = (props: Props) => {

  var colClassForLabel = props.customColClassForLabel ? props.customColClassForLabel : 'col-sm-3';
  var colClassForValue = props.customColClassForValue ? props.customColClassForValue : 'col-sm-9';

  return (
    <>
      <div className="row">
        {props.label && (
          <label htmlFor={props.id} className={`${colClassForLabel} col-form-label zvlabel`}>
            {props.label}
          </label>
        )}

        <div className={colClassForValue}>
          <textarea
            {...(props.disabled ? { disabled: true } : {})}
            value={props.value}
            id={props.id}
            className={`form-control`}
            placeholder={props.placeholder ? props.placeholder : ""}
            rows={props.rows}
            onChange={(event) => {
              props.formData[props.dataField] = event.target.value;
              if (props.setStateMethod) {
                props.setStateMethod({ ...props.formData });
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
